// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__zfP-8","errorLogs":"EditorFooter_errorLogs__2cF9t"};